
import { IData, IProjectFilter, IProjectList } from '../../../models';
import { generateAsyncSagaWatcher } from '../../../utils';
import { ISingleProject } from '../models';
import { EProjectsActions } from './enums';

export const projectsSaga = generateAsyncSagaWatcher<IData<IProjectList>>(EProjectsActions.GET_PROJECTS);

export const filterSaga = generateAsyncSagaWatcher<IData<IProjectFilter>>(EProjectsActions.GET_FILTERS);

export const projectSaga = generateAsyncSagaWatcher<IData<ISingleProject>>(EProjectsActions.GET_PROJECT);
